import { Link, useLocation } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { cn } from "../../utils/cn";

interface Crumb {
  label: string;
  href?: string;
}

const SEGMENT_LABELS: Record<string, string> = {
  "": "Dashboard",
  tenants: "Tenants",
  sagas: "Sagas",
  onboardings: "Onboardings",
  new: "Novo",
  health: "Healthcheck",
};

function isUuid(s: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(s);
}

function labelFor(segment: string, idx: number, segments: string[]): string {
  if (SEGMENT_LABELS[segment]) return SEGMENT_LABELS[segment]!;
  if (isUuid(segment)) return segment.slice(0, 8) + "…";
  // se anterior é "tenants", segment é tenant key
  if (idx > 0 && segments[idx - 1] === "tenants") return segment;
  return segment;
}

export function Breadcrumb() {
  const location = useLocation();
  const segments = location.pathname.split("/").filter(Boolean);

  const crumbs: Crumb[] = [{ label: "Dashboard", href: "/" }];
  let path = "";
  for (let i = 0; i < segments.length; i++) {
    const seg = segments[i]!;
    path += "/" + seg;
    const isLast = i === segments.length - 1;
    crumbs.push({
      label: labelFor(seg, i, segments),
      href: isLast ? undefined : path,
    });
  }

  return (
    <nav aria-label="breadcrumb">
      <ol className="flex items-center gap-1 text-xs">
        {crumbs.map((c, i) => (
          <li key={i} className="flex items-center gap-1">
            {i > 0 && <ChevronRight size={12} className="text-muted-foreground" />}
            {c.href ? (
              <Link
                to={c.href}
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                {c.label}
              </Link>
            ) : (
              <span className={cn("text-foreground font-medium", isUuid(c.label.replace("…", "")) && "font-mono-tight")}>
                {c.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
